import { render, staticRenderFns } from "./PassRestore.vue?vue&type=template&id=a844ba30&scoped=true&lang=pug&"
import script from "./PassRestore.vue?vue&type=script&lang=js&"
export * from "./PassRestore.vue?vue&type=script&lang=js&"
import style0 from "./PassRestore.vue?vue&type=style&index=0&id=a844ba30&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a844ba30",
  null
  
)

export default component.exports